module.exports = __webpack_public_path__ + "static/media/americas-tire-logo.820ef865.svg";